import { render } from "./ExpertConsultation.vue?vue&type=template&id=6baeb490&scoped=true"
import script from "./ExpertConsultation.vue?vue&type=script&lang=js"
export * from "./ExpertConsultation.vue?vue&type=script&lang=js"

import "./ExpertConsultation.vue?vue&type=style&index=0&id=6baeb490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6baeb490"]])

export default __exports__